module.exports = __webpack_public_path__ + "img/close-icon-2.f732639f.svg";